export default {
  SettingBaseDataCodeRule: {
    ruleCode: '规则编码',
    ruleName: '规则名称',

    table: {
      level: '级别',
      tenant: '租户',
      ruleCode: '规则编码',
      ruleName: '规则名称',
      ruleDescription: '规则描述',
    },

    edit: {
      msg: '基础信息',
      code: '编码段',
      type: '段类型',
      value: '段值',
      data: '日期掩码',
      min: '序列最小位数',
      start: '序列开始值',
      editMin: '最小位数',
      editStart: '开始值',
      variable: '变量',
      number: '位数',
      editCode: '编辑编码段',
      addCode: '新建编码段'
    }
  }
};
